export const TEXT_REGULAR = '400'
export const TEXT_SEMI_BOLD = '600'
export const TEXT_BOLD = '700'
